import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { performMediaUpload } from '~admin/interactor/media/perform-upload-media';
import { performMediaTranslationUpload } from '~admin/interactor/media/perform-upload-media-translation';
import { MediaData } from '~admin/model/media-data';
import { mapMediaData } from '~admin/model/media-data.mapper';
import {
  getUploadMediaRequest,
  getUploadMediaTranslationRequest,
} from '~admin/view/components/ui/form/fields/media/media-overlay/helper/media-upload-request.helper';
import { MediaUploadFormData } from '~admin/view/components/ui/form/fields/media/media-overlay/media-picker-upload.component';
import { MediaResponse } from '~client/model/media-response';
import { MediaType } from '~client/model/media-type';
import { rxTask, TwoArgTask } from '~common/helper/mobx-tasks';

export type UploadMediaAndTranslationsTask = TwoArgTask<MediaType, MediaUploadFormData, MediaData>;

export const uploadMediaAndTranslationsTaskFactory = (): UploadMediaAndTranslationsTask =>
  rxTask<MediaType, MediaUploadFormData, MediaData>(
    (mediaType: MediaType, mediaUploadFormData: MediaUploadFormData): Observable<MediaData> => {
      const formData = getUploadMediaRequest(mediaType, mediaUploadFormData);

      return performMediaUpload(formData).pipe(
        mergeMap((mediaResponse: MediaResponse) => {
          if (mediaUploadFormData.file.length > 1) {
            const formData = getUploadMediaTranslationRequest(
              mediaResponse.id,
              mediaUploadFormData,
            );
            // pipe(() => of(mediaResponse)) returns the original image for the preview and not translation
            return performMediaTranslationUpload(formData).pipe(() => of(mediaResponse));
          }
          return of(mediaResponse);
        }),
        map(mapMediaData),
      );
    },
  );



// WEBPACK FOOTER //
// ./interactor/media/upload-media-and-translations.ts